var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconLightBlueNoBgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#5062F0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.052 8.27797C8.13638 8.10771 8.30998 8 8.5 8H23.5C23.69 8 23.8636 8.10771 23.948 8.27797C24.0324 8.44824 24.013 8.65161 23.8979 8.80282L18 16.552V23.5C18 23.6772 17.9063 23.8411 17.7536 23.9309C17.6009 24.0208 17.412 24.0231 17.2572 23.9371L14.2572 22.2704C14.0984 22.1822 14 22.0149 14 21.8333V16.552L8.10213 8.80282C7.98705 8.65161 7.96762 8.44824 8.052 8.27797ZM9.5089 9L14.8979 16.0805C14.9641 16.1676 15 16.2739 15 16.3833V21.5391L17 22.6502V16.3833C17 16.2739 17.0359 16.1676 17.1021 16.0805L22.4911 9H9.5089Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconLightBlueNoBgRounded);
export default __webpack_public_path__ + "static/media/filterIconLightBlueNoBgRounded.5555abfa5a9cedb74e60fea19a59ebf4.svg";
export { ForwardRef as ReactComponent };